import React, { useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import ValidationDialog from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/NoticeDeficiency/ValidationDialog';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import RecapPostPoneExpertise from 'containers/ExpertExpertise/Recap/RecapPostPoneExpertise';
import RejectionDialog from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/NoticeDeficiency/RejectionDialog';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';

export interface PostPoneExpertiseProps {
  intl: IntlShape;
  missionPostPoneExpertise: any;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  claimId: number;
  isLawyer?: boolean;
  claimNumber: string;
  setOpenFeeNoteDialog: Function;
  requestGetDocByDocumentumId: Function;
}

const PostPoneExpertise: React.FC<PostPoneExpertiseProps> = props => {
  const [openValidationModal, setOpenValidationModal] = useState(false);
  const [openRejectionModal, setOpenRejectionModal] = useState(false);
  const [selectedPostPone, setSelectedPostPone] = useState({});
  return (
    <>
      <RecapPostPoneExpertise
        title={translate({ ...messages.postponementsExpertise }, props)}
        missionPostPoneExpertise={props.missionPostPoneExpertise}
        isManager={!props.isLawyer}
        openValidationModal={() => setOpenValidationModal(true)}
        openRejectionModal={() => setOpenRejectionModal(true)}
        setSelectedPostPone={setSelectedPostPone}
        requestUpdateMissionPostPone={() => {}}
        uploadDocument={() => {}}
        uploadedDocument={({} as unknown) as IUploadedDocument}
        resetUploadedDocument={() => {}}
        sagis_code={null}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
      <ValidationDialog
        open={openValidationModal}
        onClose={() => setOpenValidationModal(false)}
        validateDialog={props.requestMakeDecisionMissionNoticeDeficiency}
        recap={selectedPostPone}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      <RejectionDialog
        open={openRejectionModal}
        onClose={() => setOpenRejectionModal(false)}
        validateDialog={props.requestMakeDecisionMissionNoticeDeficiency}
        recap={selectedPostPone}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
      />
    </>
  );
};
export default injectIntl(PostPoneExpertise);
